import {
  ControlledTooltip,
  ControlledTooltipBody,
  ControlledTooltipTitle,
} from 'components/DtiRadialMeter/ControlledTooltip'

export const TooltipEstimatedCredit = () => {
  const componentTitle = <ControlledTooltipTitle>Estimated credit card debt</ControlledTooltipTitle>

  const componentBody = (
    <ControlledTooltipBody>
      Includes all credit cards that you are currently making payments on.
    </ControlledTooltipBody>
  )

  return <ControlledTooltip modalTitle={componentTitle} modalBody={componentBody} />
}
